import {
  ACTION_GET_ORGANIZATIONS_PRODUCTS_SETTINGS,
  ACTION_GET_ORGANIZATIONS_PRODUCTS_SETTINGS_SUCCESS,
  ACTION_GET_ORGANIZATIONS_PRODUCTS_SETTINGS_FAILURE,
  API_CALL,
} from '../../configs/ActionTypes';

import * as _ from 'lodash-es';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

export type Params = {
  id?: string;
  organizationId?: string;
};

export function getOrganizationsProductsSettings(organizationId: string) {
  return (dispatch: Dispatch, getState: Function) => {
    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: `organizations/${organizationId}/settings/products`,
        method: 'get',
        data: {},
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          if (error.payload) {
            enqueueSnackbarHandler(dispatch, error.payload, 'error');
          }
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_ORGANIZATIONS_PRODUCTS_SETTINGS_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_GET_ORGANIZATIONS_PRODUCTS_SETTINGS_FAILURE,
    payload: responseJSON,
  };
}
